export const WHATSAPP_MESSAGE_TABLE = "whatsappMessages"
// `whatsappKeyId` is indexed so the optimistic-send reconciliation loop can
// look up the real (echoed-back) row directly instead of scanning every
// message every 500 ms.
export const WHATSAPP_MESSAGE_TABLE_SCHEMA =
  "id, companyId, chatUid, status, isFromMe, timestamp, syncId, whatsappKeyId, [chatUid+timestamp]"
